import QueryDB from "@/api/queryDB/common";
import BaseModalWindow from "@/components/BaseModalWindow/BaseModalWindow";
import { createToast } from "@/utils/toaster/createToast";
import React, { FC, useState } from "react";
import { ReactComponent as ThreeDotsIcon } from "../../../../assets/actions/more-vertical.svg";
import { ReportFormModal } from "@/components/ReportFormModal/ReportFormModal";
import { DropdownMenu, Button, Spinner } from "@radix-ui/themes";
import { DotsVerticalIcon } from "@radix-ui/react-icons";

export const SinglePostDropDownActions: FC<{
  setIsDeleted: React.Dispatch<React.SetStateAction<boolean>>;
  setIsEditPost: React.Dispatch<React.SetStateAction<boolean>>;
  belongsToCurrentUser: boolean;
  isAuthorized?: boolean;
  postId: any;
  currUserSlug: string;
}> = ({
  setIsDeleted,
  setIsEditPost,
  belongsToCurrentUser,
  postId,
  currUserSlug,
  isAuthorized,
}) => {
  const [confirmModalOpen, setConfirmModalOpen] = useState<boolean>(false);
  const [deleting, isDeleting] = useState<boolean>(false);
  const [reportModal, setReportModal] = useState<boolean>(false);
  return (
    <>
      <BaseModalWindow
        show={confirmModalOpen}
        closeModal={() => {
          setConfirmModalOpen(false);
        }}
        title="Delete this post?"
      >
        <div className="modal__delete">
          <div className="delete-post">
            <div className="delete-post__body">
              <p>Are you sure you want to delete this post?</p>
            </div>
            <div className="delete-post__actions">
              <Button
                variant="outline"
                onClick={() => setConfirmModalOpen(false)}
              >
                Keep
              </Button>

              <Button
                disabled={deleting}
                variant="solid"
                onClick={async () => {
                  if (deleting) {
                    return;
                  }
                  if (!postId || !belongsToCurrentUser) {
                    return setConfirmModalOpen(false);
                  }
                  isDeleting(true);
                  setIsDeleted(true);
                  await QueryDB.deleteDoc("posts", postId)
                    .then(() => {
                      createToast({
                        type: "info",
                        message: "Post deleted.",
                      });
                    })
                    .catch(() => {
                      setIsDeleted(false);
                      createToast({
                        type: "error",
                        message: "Post failed to delete, post restored.",
                      });
                    });
                  setConfirmModalOpen(false);
                  isDeleting(false);
                  return null;
                }}
              >
                {deleting ? <Spinner /> : "Delete"}
              </Button>
            </div>
          </div>
        </div>
      </BaseModalWindow>

      {/* Report modal */}
      <ReportFormModal
        show={reportModal}
        closeModal={() => {
          setReportModal(false);
        }}
        children={""}
        reportFrom="post"
        reportItemId={postId}
      />

      {/* Actions */}
      {belongsToCurrentUser || isAuthorized ? (
        <DropdownMenu.Root>
          <DropdownMenu.Trigger>
            <Button variant="outline" color="gray">
              <DotsVerticalIcon />
            </Button>
          </DropdownMenu.Trigger>

          <DropdownMenu.Content>
            {belongsToCurrentUser ||
              (isAuthorized && (
                <DropdownMenu.Item
                  onClick={(e) => {
                    e.preventDefault();
                    setConfirmModalOpen(true);
                  }}
                >
                  Delete
                </DropdownMenu.Item>
              ))}
            {belongsToCurrentUser && (
              <DropdownMenu.Item
                onClick={(e) => {
                  setIsEditPost(true);
                  e.preventDefault();
                }}
              >
                Edit
              </DropdownMenu.Item>
            )}{" "}
          </DropdownMenu.Content>
        </DropdownMenu.Root>
      ) : (
        ""
      )}

      {!belongsToCurrentUser && !isAuthorized && (
        <DropdownMenu.Root>
          <DropdownMenu.Trigger>
            <Button variant="outline" color="gray">
              <DotsVerticalIcon />
            </Button>
          </DropdownMenu.Trigger>
          <DropdownMenu.Content>
            <DropdownMenu.Item
              onClick={(e) => {
                e.preventDefault();
                setReportModal(true);
              }}
            >
              Report
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Root>
      )}
    </>
  );
};
